import useStore from "../../../../../lib/itn-ui-kit/data/store";
import BaseRoute from "../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template.jsx";

export default class FinanceCasesListRoute extends BaseRoute {
  @service("repositories/case-repository") caseRepository;

  element = (<Template />);

  allowManualRevalidate = false;

  async loader({ request }) {
    const defaultParams = {
      "data-set": "search",
    };
    const url = new URL(request.url);
    const searchParams = Object.fromEntries(url.searchParams.entries());
    const newSearchParams = Object.assign(searchParams, defaultParams);
    const cases = await this.caseRepository.query(newSearchParams);
    const count = useStore.getState().getTotalCount("case");

    return {
      cases,
      count,
    };
  }
}
